import { Link } from 'react-router-dom'

function Footer() {
  return (
    <footer className="py-4 text-center text-sm text-muted-foreground" data-testid="auth-footer">
      <Link
        to="/privacy"
        className="hover:underline"
        data-testid="privacy-policy-link"
      >
        Privacy Policy
      </Link>
      <span className="mx-2">|</span>
      <Link
        to="/terms"
        className="hover:underline"
        data-testid="terms-of-service-link"
      >
        Terms of Service
      </Link>
    </footer>
  )
}

export default Footer
